export const QUESTION_TYPES = [
    {
        key: 'Multiple Choice Answer Type',
        value: '1',
    },
    {
        key: 'Single Choice Answer Type',
        value: '26',
    },
    {
        key: 'Numerical Answer Type',
        value: '4',
    },
    {
        key: 'INT RANGE',
        value: '5',
    },
    {
        key: 'BLANKS',
        value: '7',
    },
    {
        key: 'Match The Following',
        value: '2',
    },
    {
        key: 'Text',
        value: '0',
    },
]